/**
 * Grid and Dot Backgrounds（Aceternity UI 风格）— 网格 / 点阵背景
 */
export function GridDotBackground({
  variant = 'grid',
  className = '',
  fade = true,
}: {
  variant?: 'grid' | 'dot';
  className?: string;
  fade?: boolean;
}) {
  const backgroundImage =
    variant === 'grid'
      ? 'linear-gradient(to right, rgba(255,80,100,0.08) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,80,100,0.08) 1px, transparent 1px)'
      : 'radial-gradient(rgba(255,90,110,0.18) 1px, transparent 1px)';

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 ${className}`}
      style={{
        backgroundImage,
        backgroundSize: variant === 'grid' ? '42px 42px' : '20px 20px',
        ...(fade
          ? {
              maskImage: 'radial-gradient(circle at 50% 40%, black 25%, transparent 82%)',
              WebkitMaskImage: 'radial-gradient(circle at 50% 40%, black 25%, transparent 82%)',
            }
          : {}),
      }}
    />
  );
}
